import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    login(username, password,captcha,guidId) {
        return axios.post('auth', { username: username, password: password, captcha: captcha, guidId: guidId })
    },
    VerificateCaptch(userInput, guidId) {
        return axios.post('captcha/verifyCaptcha', {
            UserInput: userInput,
            GuidId: guidId
        })
    },
    captcha() {
        return axios.post('/captcha')
    },
    requestVerificationCode(requestVerificationCode) {
        return axios.post('auth/verify', requestVerificationCode)
    },

    checkVerificationCode(requestVerificationCode) {
        return axios.post('auth/2fa', requestVerificationCode)
    },
}